<template>
  <div id="webTop" class="max-width" v-if="this.$parent.isorder">
    <div class="wt-left">
      <div
        v-for="item in wt_left"
        :key="item.id"
        class="wt-left-view no-newline view_hover1"
      >
        {{ item.name }}
      </div>
    </div>

    <div class="wt-right">
      <div
        v-for="item in wt_right"
        :key="item.id"
        :id="item.id"
        :data-id="item.id"
        class="wt-right-view no-newline view_hover1"
        @click="func_top_click"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "webTop",
  props: {},
  data() {
    return {
      wt_left: [{ name: "欢迎来到彩航印刷！", id: "wt_welcome" }],
      wt_right: [{ name: "网站首页", id: "wt_home" }],
    };
  },
  methods: {
    func_top_click(event) {
      const id = event.currentTarget.dataset.id;
      switch (id) {
        case "wt_order": {
          this.$router.push({
            name: "orderManege",
          });
          break;
        }
        case "wt_trolley": {
          this.$router.push({
            name: "trolley",
          });
          break;
        }
        case "wt_loginOut": {
          this.$parent.func_appLoginOut();
          break;
        }
        case "wt_home": {
          this.$router.push({
            name: "home",
          });
          break;
        }
      }
    },
    // 检查登录态
    func_top_login() {
      const userinfo = this.STORAGE.get("g_userInfo");
      if (userinfo) {
        // 已登录
        if (this.wt_right[0]["id"] !== "wt-company") {
          if (!this.$parent.isorder) {
            this.wt_right = [
              { name: userinfo.company, id: "wt-company" },
              { name: "退出登录", id: "wt_loginOut" },
              { name: "网站首页", id: "wt_home" },
            ];
          } else {
            this.wt_right = [
              { name: userinfo.company, id: "wt-company" },
              { name: "我的订单", id: "wt_order" },
              { name: "购物车", id: "wt_trolley" },
              { name: "退出登录", id: "wt_loginOut" },
              { name: "网站首页", id: "wt_home" },
            ];
          }
        } else {
          this.wt_right[0]["name"] = userinfo.company;
        }
      } else {
        // 未登录
        if (this.wt_right[0]["id"] === "wt-company") {
          this.wt_right = [{ name: "网站首页", id: "wt_home" }];
        }
      }
    },
  },
};
</script>
<style scoped>
#webTop {
  /* background:#232830; */
  background: #f0f0f0;
  min-height: 30px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.wt-left {
  width: 30%;
  color: #999999;
  display: inline-flex;
}
.wt-left-view {
  height: 30px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  cursor: pointer;
}
.wt-right {
  width: 60%;
  color: #999999;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
#wt-company {
  max-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.wt-right-view {
  height: 30px;
  font-size: 12px;
  margin-left: 10px;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 4px;
  cursor: pointer;
}
@media only screen and (max-width: 480px) {
  #webTop {
    display: none;
  }
  /* .wt-right-view{
		display: none;
	}
	.wt-left-view{
		display: none;
	} */
}
</style>



// WEBPACK FOOTER //
// src/components/webTop.vue